export default "__VITE_ASSET__Dnb6Soeu__"